import { type FC, useMemo } from 'react'

import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/table/table'
import { Tag } from '@/components/tag/tag'

import { cn } from '@/lib/utils'

import { COLUMN_DEFINITIONS } from '../../constants'
import type { RowValidated } from '../../types'

export interface PreviewProps {
  rows: RowValidated[]
}

export const ImportPreview: FC<PreviewProps> = ({ rows }) => {
  const nInvalidRows = useMemo(() => rows.filter((row) => !!row.hasError).length, [rows])

  const tableColumns = [
    COLUMN_DEFINITIONS.applicantName,
    COLUMN_DEFINITIONS.applicantEmail,
    COLUMN_DEFINITIONS.applicantPhone,
    COLUMN_DEFINITIONS.applicantTags,
    COLUMN_DEFINITIONS.category,
    COLUMN_DEFINITIONS.caseNumber,
    COLUMN_DEFINITIONS.caseTags,
  ] as const

  if (rows.length === 0) {
    // No rows
    return null
  }

  if (rows.length === nInvalidRows) {
    // No valid rows
    return null
  }

  return (
    <div>
      <div className="mb-4 font-medium">Preview of your file</div>

      <div className="mb-5 h-[222px] overflow-scroll rounded-md border">
        <Table>
          <TableHeader>
            <TableRow>
              {tableColumns.map((columnItem, index) => (
                <TableHead key={index}>{columnItem.displayName}</TableHead>
              ))}
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.map((row, i) => (
              <TableRow className={cn(!!row.hasError && 'bg-red-200 text-red-500 hover:bg-red-200')} key={i}>
                <TableCell>{row[COLUMN_DEFINITIONS.applicantName.csvColumnName]}</TableCell>
                <TableCell>{row[COLUMN_DEFINITIONS.applicantEmail.csvColumnName]}</TableCell>
                <TableCell>{row[COLUMN_DEFINITIONS.applicantPhone.csvColumnName]}</TableCell>
                <TableCell>
                  <div className="flex gap-1">
                    {row[COLUMN_DEFINITIONS.applicantTags.csvColumnName]
                      ?.split(/\s*,\s*/)
                      .map((x) => <Tag key={x}>{x}</Tag>)}
                  </div>
                </TableCell>
                <TableCell>{row[COLUMN_DEFINITIONS.category.csvColumnName]}</TableCell>
                <TableCell>{row[COLUMN_DEFINITIONS.caseNumber.csvColumnName]}</TableCell>
                <TableCell>
                  <div className="flex gap-1">
                    {row[COLUMN_DEFINITIONS.caseTags.csvColumnName]
                      ?.split(/\s*,\s*/)
                      .map((x) => <Tag key={x}>{x}</Tag>)}
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  )
}
